import { useTranslation } from 'react-i18next';
import type { StaticSharedField } from './types';
import type { quantityDropdownValue } from '/business/shared/components/pages/question/types';
import {
  ERR_TYPE_NUM_LARGE,
  ERR_TYPE_NUM_SMALL,
  ERR_TYPE_REQUIRED,
  FIELD_TYPE_NUMBER,
} from '/business/shared/components/questions/helper/fieldEnums';

export default function useScope3Data({
  isAbsoluteUnits = false,
  dropdownValues,
}: {
  isAbsoluteUnits?: boolean;
  dropdownValues: quantityDropdownValue[];
}): StaticSharedField {
  const { t } = useTranslation();

  return {
    type: FIELD_TYPE_NUMBER,
    label: <div>Scope 3 emissions:</div>,
    inputMode: !isAbsoluteUnits ? 'decimal' : 'number',
    step: '.01',
    propName: 'scope3_data_amount',
    element: 'scope3_data_amount',
    subLabel: <div>(Indirect emissions)</div>,
    // set to ' ', as we're using label as JSX, so if placeholder gets set to component it becomes object [object]
    placeholderI18nKey: ' ',
    validation: [
      {
        rule: ERR_TYPE_REQUIRED,
        errCode: 'ERRNOSCOPE3EMISSIONS',
        errStr: t('business:Errors.supplierForm.scope3Intensity'),
      },
      {
        rule: ERR_TYPE_NUM_SMALL,
        errCode: 'ERRSCOPE3EMISSIONSTOOLOW',
        errStr: t('business:Errors.supplierForm.scope3Intensity'),
        value: 0,
      },
      {
        rule: ERR_TYPE_NUM_LARGE,
        errCode: 'ERRSCOPE3EMISSIONSTOOHIGH',
        errStr: t('business:Errors.supplierForm.scope3Intensity'),
        value: 9999999,
      },
    ],
    dropdown: {
      propName: 'scope3_data_amount_unit',
      values: dropdownValues,
    },
  };
}
